import {loadStripe} from "@stripe/stripe-js";
import {Elements, PaymentElement, useStripe} from '@stripe/react-stripe-js';
import {getSetting} from '@woocommerce/settings'
import {cloneDeep} from 'lodash';

import {useProcessCheckoutError, useProcessCheckoutSuccess, useCreatePaymentMethod, useElementOptions} from "../hooks";
import {getPaymentElementTerms} from '@wc-stripe/blocks-utils';

const {publishableKey, stripeParams} = getSetting('stripeGeneralData');
const params = cloneDeep(stripeParams);

const stripe = loadStripe(publishableKey, params);


const data = getSetting('stripe_cc_data');

export const PaymentElementComponent = (props) => {
    const {billing, shouldSavePayment} = props;
    const {cartTotal, currency} = billing;
    const standardOptions = useElementOptions({
        cartTotal,
        currency,
        elementOptions: data.elementOptions,
        shouldSavePayment
    });
    const options = (data.installmentsActive && data.clientSecret)
        ? {clientSecret: data.clientSecret, locale: data.elementOptions.locale}
        : standardOptions;
    return (
        <>
            <Elements stripe={stripe} options={options}>
                <CardElement {...props} options={options}/>
            </Elements>
        </>
    );
}

const CardElement = ({options, ...props}) => {
    const gatewayId = data.gatewayId;
    const shouldCreatePaymentMethod = !data.installmentsActive;
    const {
        billing: {billingAddress},
        eventRegistration,
        emitResponse,
        shouldSavePayment,
        activePaymentMethod
    } = props;
    const {
        email,
        phone,
        first_name,
        last_name
    } = billingAddress;
    const {
        onCheckoutSuccess,
        onCheckoutFail
    } = eventRegistration;

    const name = data.name;

    const {clearPaymentMethodData} = useCreatePaymentMethod({
        name,
        gatewayId,
        emitResponse,
        billingAddress,
        shouldSavePayment,
        eventRegistration,
        activePaymentMethod,
        shouldCreatePaymentMethod
    });

    useProcessCheckoutSuccess({
        name,
        emitResponse,
        billingAddress,
        onCheckoutSuccess,
        activePaymentMethod
    });

    useProcessCheckoutError({
        emitResponse,
        subscriber: onCheckoutFail,
        messageContext: emitResponse.noticeContexts.PAYMENTS,
        clearPaymentMethodData
    });

    const elementOptions = {
        defaultValues: {
            billingDetails: {
                name: `${first_name} ${last_name}`,
                email,
                phone
            }
        },
        fields: {
            billingDetails: {
                address: 'never',
                name: 'never',
                email: 'never',
                phone: !!phone ? 'never' : 'auto'
            }
        },
        wallets: {
            applePay: 'never',
            googlePay: 'never',
            link: data.elementOptions.paymentMethodTypes.includes('link') ? 'auto' : 'never'
        },
        terms: getPaymentElementTerms(data.termsDisplayRule),
        ...data.paymentElementOptions
    }
    return (
        <>
            <PaymentElement options={elementOptions}/>
        </>
    )
}

export default PaymentElementComponent;